<template>
  <div id="New_marker" class="xv_modal">
    <div class="modal_title">
      <div>
        <span>New marker</span>
      </div>
      <div>
        <button class="modal_close" @click="close_new_marker()">
          <span class="mdi mdi-close"></span>
        </button>
      </div>
    </div>
    <div class="modal_content" v-if="success == false">
      <div class="row">
        <div class="col-12">
          <label>Name</label>
          <input type="text" placeholder />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>Type</label>
          <select name id @change="marker_type">
            <option value>Choose type</option>
            <option value="beacon">Beacon</option>
            <option value="qr">QR Code</option>
            <option value="s_gm">Status Geo Marker</option>
            <option value="s_qr">Status QR Code</option>
          </select>
        </div>
      </div>
      <div class="row" v-if="m_type == 'beacon'">
        <div class="col-12">
          <input type="text" placeholder="Id" />
        </div>
      </div>
      <div class="row" v-if="m_type == 'qr'">
        <div class="col-12">
          <div class="marker_qr_details">
            <textarea placeholder="Description" rows="2"></textarea>
          </div>
          <div class="marker_qr_details row">
            <div class="col-2">
              <span class="title">Company</span>
            </div>
            <div class="col-10">
              <span>Alphabet</span>
            </div>
          </div>
          <div class="marker_qr_details row">
            <div class="col-2">
              <span class="title">Office</span>
            </div>
            <div class="col-10">
              <span>Infocity</span>
            </div>
          </div>
          <div class="marker_qr_details row">
            <div class="col-2">
              <span class="title">Location</span>
            </div>
            <div class="col-10">
              <span>40.741895, -73.989308</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="m_type == 's_gm'">
        <div class="col-12">
          <span class="note">
            This is available for Premium Plan.
            <a href="#">Contact us for pricing</a>
          </span>
        </div>
      </div>
      <div class="row" v-if="m_type == 's_qr'">
        <div class="col-12">
          <span class="note">
            This is available for Premium Plan.
            <a href="#">Contact us for pricing</a>
          </span>
        </div>
      </div>
    </div>
    <div class="modal_content" v-if="success == true">
      <div class="qr_print_preview">
        <div class="col-12 text-center">
          <div>
            <label class="company">Infocity</label>
            <label class="description">East street, Main entrance</label>
          </div>
          <img class="main_qr" src="../../../../assets/qrcode.png" alt />
          <br />
          <div>
            <label class="secured">
              Secured by
              <span class="highlight">XV</span>
            </label>
          </div>
          <div class="meta">
            <div>
              <img class="download_app" src="../../../../assets/play.png" alt />
            </div>
            <div>
              <img class="download_app" src="../../../../assets/app.png" alt />
            </div>
            <div>
              <img class="download_qr" src="../../../../assets/qrcode.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_footer" v-if="success == false">
      <button class="sec_btn m_r" @click="close_new_marker()">Cancel</button>
      <button class="main_btn" @click="success = true">Add</button>
    </div>
  </div>
</template>

<script>
// import employeePolicies from "./employee_policies/employee_policies.vue"

export default {
  name: "New_marker",
  components: {
    // employeePolicies,visitorPolicies,healthDeclarations,securityPartners,company,account
  },
  data() {
    return {
      m_type: "",
      success: false
    };
  },
  methods: {
    close_new_marker: function() {
      this.$modal.hide("new_marker");
    },
    marker_type: function(e) {
      var value = e.currentTarget.value;
      this.m_type = value;
    }
  }
};
</script>
